<div placement="top" trigger="click" hideDelayAfterClick="1500" (click)="copyToClipboard()" matTooltip="Link copied to clipboard">
  <ng-content></ng-content>
</div>
